// src/Pages/Catalog/index.tsx
import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import Clothing from "./Clothing";
import Deals from "./deals";
import EmailClothe from "./EmailClothe";
import { CommonService } from "Components/CommonService";

const Catalog = () => {
  const { slug } = useParams(); // works for /category/:slug OR /catalog/:slug (if your route uses that)

  const title = useMemo(() => {
    if (slug) return `${slug} | Toner - React FrontEnd`;
    return "Catalog | Toner - React FrontEnd";
  }, [slug]);

  document.title = title;

  return (
    <React.Fragment>
      {/* ✅ PASS slug to product section */}
      <Clothing category_slug={slug} />
      <CommonService />
    </React.Fragment>
  );
};

export default Catalog;